import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AddNewPasswordComponent } from "./component/root/login/add-new-password/add-new-password.component";
import { ForgotPasswordComponent } from "./component/root/login/forgot-password/forgot-password.component";
import { CustomPreloadingService } from "./customPreloading/custom-preloading.service";
import { ForgetUsernameComponent } from './component/root/login/forget-username/forget-username.component';
import { RoleComponent } from './component/feature/umgr/role/role.component';
import { PrivilegeComponent } from './component/feature/umgr/privilege/privilege.component';
import { MenuComponent } from "./component/feature/umgr/menu/menu.component";
import { LoginComponent } from "./component/root/login/login.component";
import { AccessDenied } from "./component/root/layout/access-denied/access-denied.component";
import { AuthenticationGuard } from "./helper/authentication.guard";
import { ShiftDetailsComponent } from "./component/feature/shift-details/shift-details.component";
import { ResetPasswordVerify } from "./component/root/login/reset-password-verify/reset-password-verify";
import { InteractiveGeofenceComponent } from "./component/feature/interactive-geofence/interactive-geofence.component";
import { ZoneManagementComponent } from "./component/feature/zone-management/zone-management.component";
import { GeofenceComponent } from "./component/feature/geofence/geofence.component";
import { PaymentDetailSearchComponent } from "./component/feature/payment-detail-search/payment-detail-search.component";
import { InteractiveZoneComponent } from "./component/feature/interactive-zone/interactive-zone.component";
import { AllGeofenceComponent } from "./component/feature/all-geofence/all-geofence.component";
import { NumplatePaymentSearchComponent } from "./component/feature/numplate-payment-search/numplate-payment-search.component";
import { NumplatePermitSearchComponent } from "./component/feature/numplate-permit-search/numplate-permit-search.component";
import { PaymentApiNumplateSearchComponent } from "./component/feature/payment-api-numplate-search/payment-api-numplate-search.component";
import { ChartShiftDetailComponent } from "./component/feature/chart-shift-detail/chart-shift-detail.component";
import { DashboardSuperComponent } from "./component/feature/dashboard-super/dashboard-super.component";
import { DashboardOrganizationComponent } from "./component/feature/dashboard-organization/dashboard-organization.component";
import { ChartDailyShiftDetailsComponent } from "./component/feature/chart-daily-shift-details/chart-daily-shift-details.component";
import { CitationManagementComponent } from "./component/feature/citation-management/citation-management.component";
import { EnforcementVehicleComponent } from "./component/feature/enforcement-vehicle/enforcement-vehicle.component";
import { EventManagementComponent } from './component/feature/event-management/event-management.component';
import { PaymentsTestingComponent } from "./component/feature/payments-testing/payments-testing.component";
import { DashboardComponent } from "./component/feature/dashboard/dashboard.component";
import { ConfigurationComponent } from "./component/feature/configuration/configuration.component";

const routes: Routes = [
  { path: "", component: LoginComponent, pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "add-new-password", component: AddNewPasswordComponent },
  { path: "forget-password", component: ForgotPasswordComponent },
  { path: "forget-username", component: ForgetUsernameComponent },
  { path: "admin/role", component: RoleComponent },
  { path: "admin/privilege", component: PrivilegeComponent },
  { path: "admin/menu", component: MenuComponent },
  { path: "access-denied", component: AccessDenied },
  { path: "dashboard", component: DashboardComponent },
  { path: "shift-details", component: ShiftDetailsComponent },
  { path: "interactive-geofence", component: InteractiveGeofenceComponent },
  { path: "reset-password-verify/:token", component: ResetPasswordVerify},
  { path: "zone-management", component: ZoneManagementComponent},
  { path: "geofence", component: GeofenceComponent},
  { path: "gateway-data-details", component: PaymentDetailSearchComponent},
  { path: "payment-details", component: NumplatePaymentSearchComponent},
  { path: "permit-details", component: NumplatePermitSearchComponent},
  { path: "payment-api-details", component: PaymentApiNumplateSearchComponent},
  { path: "interactive-zone", component: InteractiveZoneComponent},
  { path: "all-geofence", component: AllGeofenceComponent},
  // { path: "dashboard-super", component: DashboardSuperComponent},
  { path: "dashboard-organization", component: DashboardOrganizationComponent},
  { path: "chart-shift-detail", component: ChartShiftDetailComponent},
  { path: "chart-daily-shift-details", component: ChartDailyShiftDetailsComponent},
  {
    path: "user", data: { preload: false, role:"User" }, loadChildren: () =>
      import("./component/feature/user/user.module").then((m) => m.UserModule),
  },

  {
    path: "organization", data: { preload: false,role: "Organization"}, loadChildren: () =>
      import("./component/feature/organization/organization.module").then((m) => m.OrganizationModule),
  },
  
  {
    path: "admin/preference", data: { preload: false }, loadChildren: () =>
      import("./component/feature/preference/preference.module").then(
        (m) => m.PreferenceModule),
  },
 
  {
    path: 'lpr-config', loadChildren: () =>
      import('./component/feature/LPR/lprConfig/lpr-config.module').then(
        m => m.LprConfigModule)
  },
  {path: "citation-management", component: CitationManagementComponent},
  {path: "enforcement-vehicle", component: EnforcementVehicleComponent},
  {path: "event-management", component: EventManagementComponent},
  {path: "payment-testing", component: PaymentsTestingComponent},
  {path: "configuration", component: ConfigurationComponent}
 
  // {
  //   path: "lpr-data", data: { preload: false}, loadChildren: () =>
  //     import("./component/feature/LPR/lprData/lpr-data.module").then(
  //       (m) => m.LprDataModule),
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      useHash: true,
      preloadingStrategy: CustomPreloadingService,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
